import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { getElementDisplayName } from '../../utils/getElementDisplayName'
import { Select } from 'alurkerja-ui'
import { handleFieldTypeChange } from './utils/handleFieldTypeChange'
import React, { useEffect, useState } from 'react'
import NumberSeparator from './NumberSeparator'

type EditFieldTypeProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

const listOption = [
  { value: 'INPUT_TEXT', label: 'Input' },
  { value: 'INPUT_NUMBER', label: 'Number' },
  { value: 'INPUT_EMAIL', label: 'Email' },
  { value: 'INPUT_PASSWORD', label: 'Password' },
  { value: 'INPUT_DATE', label: 'Date' },
  { value: 'INPUT_TIME', label: 'Time' },
  { value: 'INPUT_DATETIME-LOCAL', label: 'Date Time' },
  { value: 'INPUT_TEXTAREA', label: 'Textarea' },
]

export default function EditFieldType(props: EditFieldTypeProps) {
  const { element, currentElementState, setCurrentElementState } = props

  // Validation: Check if current value exists in listOption
  const currentValue = currentElementState[element]
  const isValidValue = listOption.some((option) => option.value === currentValue)

  const [separator, setSeparator] = useState<{
    currency: string
    separator: {
      type: string
      thousand: string
      decimal: string
    }
  }>({
    currency: currentElementState?.separator?.currency || '',
    separator: {
      type: currentElementState?.separator?.separator?.type || '',
      thousand: currentElementState?.separator?.separator?.thousand || '',
      decimal: currentElementState?.separator?.separator?.decimal || ''
    }
  })

  if (!isValidValue) {
    return null
  }

  useEffect(() => {
    if(currentValue == 'INPUT_NUMBER') {
      setCurrentElementState({
        ...currentElementState,
        separator,
        defaultValue: separator.separator.type === '' ? null : currentElementState['defaultValue']
      })
    } else {
      setCurrentElementState((prevState: any) => {
        const newState = { ...prevState };

        delete newState.separator;

        return newState;
      });
    }
  }, [separator, currentValue])

  return (
    <div className="flex flex-col gap-0 p-3">
      <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
      <div className="w-full">
        <Select
          styles={{
            control: () => ({}),
            valueContainer: () => ({
              display: 'flex',
              flexWrap: 'wrap',
              flex: 1,
              alignItems: 'center',
              overflow: 'hidden',
            }),
            input: () => ({ gridArea: '1 / 1 / 2 / 3' }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected ? '#0095E8' : '#fff',
              ':hover': { backgroundColor: '#E4E6EF', color: '#000' },
            }),
            menuList: (base) => ({
              ...base,
              maxHeight: '200px',
              overflowY: 'auto',
            }),
          }}
          classNames={{
            control: () =>
              'h-9 text-sm px-2.5 flex rounded-lg border py-2 bg-white focus:ring-main-blue-alurkerja focus-within:ring-main-blue-alurkerja focus-within:border-main-blue-alurkerja focus:border-main-blue-alurkerja',
            valueContainer: () => 'p-0 overflow-hidden relative grid items-center flex-1',
            input: () => 'visible',
          }}
          isSearchable={false}
          options={listOption}
          defaultValue={{
            value: currentElementState[element] || 'INPUT_TEXT',
            label: listOption.find((option) => option.value === currentElementState[element])?.label || 'Input',
          }}
          onChange={(value: any) => {
            handleFieldTypeChange(value, currentElementState, setCurrentElementState, element)
          }}
        />

        {currentValue == 'INPUT_NUMBER' && (
          <NumberSeparator
            separator={separator}
            setSeparator={setSeparator}
          />
        )}
      </div>
    </div>
  )
}
